// Step form js
var currentTab = 0;
var currentSubTab = 0;

function openModal(evt, cityName) {
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("items-selection-container");
    for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tab-link");
    for (i = 0; i < tablinks.length; i++) {
        tablinks[i].classList.remove("active");
    }

  
    var allSubTabs = document.getElementById(cityName).querySelectorAll('.tab-link1')
    let activeSubTab = false
    
    for(var i = 0; i <allSubTabs.length; i++){
      if(allSubTabs[i].classList.contains('active')) activeSubTab = allSubTabs[i]
    }
    if(!activeSubTab) activeSubTab = allSubTabs[0]
  
    for(var i =0; i < tablinkss.length; i++){
      if(tablinkss[i] == activeSubTab) currentSubTab = i
    }

    console.log('current subTab inside openModal ', currentSubTab)
  
    document.getElementById(cityName).style.display = "block";
    evt.currentTarget.classList.add("active");
    currentTab = Array.prototype.indexOf.call(tablinks, evt.currentTarget);
    // updateButtonVisibility();

    // Add the logic to display the first .items-selection-container1
    var collection = evt.currentTarget.getAttribute("data-collection");
    var firstContainer = document.querySelector(
        '.items-selection-container[data-collection="' +
        collection +
        '"] .items-selection-container1'
    );
    if (firstContainer) {
        firstContainer.style.display = "block";
    }
    nextClick(document.getElementById(evt.currentTarget.getAttribute("data-collection")).querySelector('.tab-container').querySelector('.active'));
}
function showNextContent() {
    var tablinks = document.getElementsByClassName("tab-link");
    if (currentTab + 1 < tablinks.length) {
        var nextTab = currentTab + 1;
        tablinks[nextTab].click();
    } else {
    }
    console.log('next button is clicked successfully');
    window.scrollTo({ top: 0, behavior: 'smooth' });
    // updateButtonVisibility();
}


var tablinkss = document.getElementsByClassName("tab-link1");
var tabNavigation = {};

for (let i = 0; i < tablinkss.length; i++) {
    tablinkss[i].addEventListener("click", function () {
        var tabIndex = parseInt(this.getAttribute("data-tab-index"));
        showTab(i);
    });
    tabNavigation[i] = { clicked: false };
}

function showTab(tabIndex) {
    var tablinkss = document.getElementsByClassName("tab-link1");

  console.log("tablinkss length: "  , tablinkss.length);
  
  console.log('tab index inside showTab: ', tabIndex)
  
    if (tabIndex >= 0 && tabIndex <= tablinkss.length) {
        tablinkss[tabIndex].click();
        tabNavigation[tabIndex].clicked = true; // Update the navigation state
        currentSubTab = tabIndex; // Update currentSubTab
    }
}


var escapeBtn = document.getElementById('tab-link-1');

// Call this function when the "Next" button is clicked
async function onNextButtonClick() {
  console.log('clicked next button sir')
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (currentSubTab === null) {
        // If no manual tab selection, find the next tab that hasn't been clicked
        var nextTab = null;
        for (var i = 0; i < tablinkss.length; i++) {
            if (!tabNavigation[i].clicked) {
                nextTab = i;
              console.log(nextTab)
                break;
            }
        }

        if (nextTab !== null) {
            showTab(nextTab);
        } else {
            console.log("All tabs are finished.");
        }
    } else {

      
      currentSubTab = currentSubTab + 1
      console.log("Hey, opening new sub tab: ", currentSubTab)
        showTab(currentSubTab);
    }
    // updateButtonVisibility();
}

var nextButton = document.getElementById("next-button"); 
nextButton.addEventListener("click", onNextButtonClick);

function showPreviousContent() {
    var tablinks = document.getElementsByClassName("tab-link");
    if (currentTab - 1 >= 0) {
        var prevTab = currentTab - 1;
        tablinks[prevTab].click();
    }
}

function openNewModal(evt, collection) {
    var i, tabcontent, tablinks;
    var parentOfCurentStep = evt.target.parentElement.parentElement;
    tabcontent = parentOfCurentStep.getElementsByClassName(
        "items-selection-container1"
    );
    tabcontent[0].style.display = "block";
    for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
    }
    tablinks = parentOfCurentStep.getElementsByClassName("tab-link1");
    for (i = 0; i < tablinks.length; i++) {
        tablinks[i].classList.remove("active");
    }
    document.getElementById(collection).style.display = "block";

    evt.currentTarget.classList.add("active");
    nextClick(evt.currentTarget);

}
function nextClick(evt) {
    console.log(evt);
    let indexOfCurrentlyActiveTab = evt.getAttribute("data-index");
    let totalNumberOfTabs = evt.getAttribute("data-number-tab");
    // find the index of active tab
    // find the total number of tabs
    // if(index of active tab == total number of tabs) hide small next button

    if (parseInt(indexOfCurrentlyActiveTab) === parseInt(totalNumberOfTabs)) {
        document.getElementById("next-button").style.display = "none";
        document.getElementById("main-button").style.display = "block";
    } else {
        document.getElementById("next-button").style.display = "block";
        document.getElementById("main-button").style.display = "none";
    }
}
document.getElementById("defaultOpen").click();

window.addEventListener("load", (event) => {
  // Add button js
  var itemArray = [];
  var productArray = [];
  var uniqueProducts = [];
  $(".add-to-box").click(function (e) {
    e.preventDefault();
    var productId = parseInt($(this).attr("data-product-id"));
    var productSubscriptionId = parseInt(
      $(this).attr("data-product-subscription")
    );
    var productPrice = parseInt($(this).attr("data-price"));
    var productSubscriptionPercentage = parseInt(
      $(this).attr("data-subscription-discount")
    );
    var productQty = 1;
    var obj;
    var productObj;
    if (productSubscriptionId == "Null") {
      obj = {
        id: productId,
        quantity: productQty,
      };
      productObj = {
        id: productId,
        quantity: productQty,
        price: productPrice,
      };
    } else {
      obj = {
        id: productId,
        selling_plan: productSubscriptionId,
        quantity: productQty,
      };
      productObj = {
        id: productId,
        quantity: productQty,
        price: productPrice,
        selling_plan: productSubscriptionId,
        selling_discount: productSubscriptionPercentage,
      };
    }
    
     let productID = $(e.target).data("product-id");
      let productTitle = $(e.target)
    .closest(".card-content-wrapper")
    .find(".product_title")
    .text();
     
     let imageUrl =  $(this).closest('.product-card-wrapper').find('.card-featured-img').attr('src');
    
       const quantitycontainer = $('.card-content-wrapper').on('click', '.js-qty__adjust--minus, .js-qty__adjust--plus', function() {
       quantityInputValue = $(this).closest('.card-content-wrapper').find('.card-qunatity-input').val();
    });  
        let quantityValue = quantitycontainer.closest('.card-content-wrapper').find('.card-qunatity-input').val();
    
        let productIndex = uniqueProducts.findIndex(
            (item) => item.id === productID
          );
          if (productIndex === -1) {
              uniqueProducts.push({ id: productID, name: productTitle , image: imageUrl , quantity: quantityValue });
          } else {
              console.log("Product already in the cart.");
          }
      
    // const quantityInput = $(e.target).closest('.card-content-wrapper').find('.card-qunatity-input').attr('value');
    // console.log("quantityInput", quantityInput);

    // const minusButton = $(this).closest('.card-content-wrapper').find('.decrease-quantity');

    // minusButton.on("click", function () {
      
    //   let currentValue = parseInt(quantityInputValue);
    //   console.log("currentValue", currentValue);
    //     console.log(uniqueProducts);
    
    //   if (currentValue === 1) {
    //    let productID = $(e.target).data("product-id");
    //     removeItems(productID);
         
    //   } else{
        
    //   }
    // });
    
    reRender();
    var dataProductValue = $(".selected-product-container").attr("data-product")

    var exists = itemArray.some((item) => item.id === obj.id);
    var productExists = productArray.some(
      (productItem) => productItem.id === productObj.id
    );

    if (!exists) {
      itemArray.push(obj);
      $(this).parent().next().removeClass("hidden");
      $(this).parent().addClass("hidden");
    }

    if (!productExists) {
      productArray.push(productObj);
      calculateTotalPrice();
    }

    itemLengthCheck();
     var quantityInputMax = $(this).parent().next().find('.card-qunatity-input');
     var quantityValueMax = quantityInputMax.attr('max');
      if (quantityValueMax == 1){
      quantityInputMax.next().addClass('disabled');
      return;
    }
  });
  reRender()

     function reRender() {
      
      const selectedListDiv = $(".selected-list");
      const displayedIds = []; // Array to track displayed IDs

      function addItem(item) {
          if (!displayedIds.includes(item.id)) {
              const itemHtml = `<div id="product-${item.id}" class="selected-modal-wrapper">
                <div class="selected-product-container" data-product="${item.id}">
                  <div class="model-selected-image">
                    <span class="quantityValues">${item.quantity}</span>
                    <img src=${item.image}/>
                  </div>
                  <div class="selected-product-title">
                    <p>${item.name}</p>
                  </div>
                </div>
              </div>`;
              displayedIds.push(item.id);
              selectedListDiv.append(itemHtml);
          }
      }
      
      if (uniqueProducts.length === 0) {
          selectedListDiv.html(`<div class="empty-wrapper"><p class="empty-section">Product not selected. Please Select the Product!</p></div>`);
      } else {
          selectedListDiv.empty();
          uniqueProducts.forEach((item) => {
              addItem(item);
          });
      }
   }
  
   // Function to update quantity based on input change
  function updateQuantity1(input) {
    const inputId = parseInt(input.attr("data-product-id"));

    // Find the index of the object in itemArray with matching ID
    const index = uniqueProducts.findIndex((item) => item.id === inputId);
    // const productIndex = uniqueProducts.findIndex(
    //   (productItem) => productItem.id === inputId
    // );

    if (index !== -1) {
      // Update the quantity of the object in itemArray
      uniqueProducts[index].quantity = parseInt(input.val());
      // $(`#product-${productID}`).update();
    } else {
      console.log("Item not found in array.");
    }

    // if (productIndex !== -1) {
    //   // Update the quantity of the object in productArray
    //   productArray[productIndex].quantity = parseInt(input.val());
    // }
  }

  function calculateTotalPrice() {
    var totalPriceData = calculateTotalPriceWithDiscount(productArray);
    var roundedTotalPrice = totalPriceData.totalPrice.toFixed(2);
    var roundedTotalOriginalPrice =
      totalPriceData.totalOriginalPrice.toFixed(2);

    var totalSaved =
      totalPriceData.totalOriginalPrice - totalPriceData.totalPrice;
    var roundedTotalSaved = totalSaved.toFixed(2);

    $(".selected-total-price").text("$" + roundedTotalPrice);
    $(".saved-subs-amount").text(`(You've Saved $${roundedTotalSaved})`);
  }

  // Calculate the sum of prices after applying selling discount percentage and considering quantity
  function calculateTotalPriceWithDiscount(products) {
    var totalPrice = 0;
    var totalOriginalPrice = 0;

    for (var i = 0; i < products.length; i++) {
      var product = products[i];
      var discountedPrice =
        product.price * (1 - product.selling_discount / 100);
      var totalPriceForProduct = discountedPrice * product.quantity;
      totalPrice += totalPriceForProduct;
      totalOriginalPrice += product.price * product.quantity;
    }

    return {
      totalPrice: totalPrice,
      totalOriginalPrice: totalOriginalPrice,
    };
  }

  $(".card-qunatity-input").change(function (e) {
    e.preventDefault();
    updateQuantity1($(this));
    updateQuantity($(this));
    calculateTotalPrice();
    itemLengthCheck();
  });

  function itemLengthCheck() {
    if (itemArray.length >= 1 && uniqueProducts.reduce((total, uniqueProducts) => total + parseInt(uniqueProducts.quantity), 0) >=3 ) {
      $("#final-checkout").removeClass("disabled");
    } else {
      $("#final-checkout").addClass("disabled");
    }
  }

  $(document).on('click',".increase-quantity",function (e) {
    e.preventDefault();
    var input = $(this).prev();
    var currentVal = parseInt(input.val());
    // console.log("value", $(this).prev().attr('max'));
    var quantityValue = $(this).prev().attr('max');

    var newVal = currentVal + 1;
    input.val(newVal);
    input.trigger("change");
    reRender();
    itemLengthCheck();
    if (newVal >= quantityValue && quantityValue >= 0){
      $(this).addClass('disabled');
      return;
    }
  });

  $(document).on('click',".decrease-quantity",function (e) {
    e.preventDefault();
    var input = $(this).next();
    var currentVal = parseInt(input.val());
    var newVal = currentVal - 1;
    if (newVal === 0) {
      removeProduct(input);
      $(this).parent().parent().prev().removeClass("hidden");
      $(this).parent().parent().addClass("hidden");
      calculateTotalPrice();
      
    var pId =  $(this).next().attr('data-product-id')
     removeItems(pId)
    } else {
      input.val(newVal);
      input.trigger("change");
    }
    reRender()
    itemLengthCheck();
     var quantityValue = $(this).next().attr('max');
     if (newVal < quantityValue ){
      $('.increase-quantity').removeClass('disabled');
      return;
    }
  });

  // function to remove view products removed item
    function removeItems(items) {
        const productID = items;
        const index = uniqueProducts.findIndex((item) => item.id == productID);
        
       if (index !== -1) {
           uniqueProducts.splice(index, 1);
           $(`#product-${productID}`).remove();
        } else {
          console.log("Item not found in array.");
        }
    }

  // Function to remove product
  function removeProduct(input) {
    const inputId = parseInt(input.attr("data-product-id"));

    // Find the index of the object in itemArray with matching ID
    const index = itemArray.findIndex((item) => item.id === inputId);
    
    const productIndex = productArray.findIndex(
      (productItem) => productItem.id === inputId
    );

       if (index !== -1) {
      itemArray.splice(index, 1);
    } else {
      console.log("Item not found in array.");
    }

    if (productIndex !== -1) {
      productArray.splice(index, 1);
    }
    itemLengthCheck();
  }

  // Function to update quantity based on input change
  function updateQuantity(input) {
    const inputId = parseInt(input.attr("data-product-id"));

    // Find the index of the object in itemArray with matching ID
    const index = itemArray.findIndex((item) => item.id === inputId);
    const productIndex = productArray.findIndex(
      (productItem) => productItem.id === inputId
    );

    if (index !== -1) {
      // Update the quantity of the object in itemArray
      itemArray[index].quantity = parseInt(input.val());
      console.log("Quantity updated:", itemArray);
    } else {
      console.log("Item not found in array.");
    }

    if (productIndex !== -1) {
      // Update the quantity of the object in productArray
      productArray[productIndex].quantity = parseInt(input.val());
    }
  }

  $("#final-checkout").click(function (e) {
    e.preventDefault();
    let formData = {
      items: itemArray,
    };
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        // if(response.status === 200){
        console.log("success:", response);
        window.location.href = "/checkout";
      // } 
        // if(response.status === 422){
        // console.log("success:", response);
        //   const popUp = $('#popUpMessage');
        //   popUp.text("messages"); 
        //   popUp.css('display', 'block'); 
          
        //   setTimeout(function() {
        //     popUp.css('display', 'none'); 
        //   }, 10000);
        //   }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  });
});
